export { default } from './Boleto25Perguntas';
